import { organizationHelper } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';

export class ParentAccount extends LitEntity {
  static get properties() {
    return {
      accountHref: { type: String, attribute: false },
    };
  }

  render() {
    return html`
      <lit-entity .href="${this.accountHref}" @update="${this._onUpdateAccount}"></lit-entity>
    `;
  }

  _onUpdateAccount(event) {
    this.dispatchEvent(new CustomEvent('load-account', { detail: { entity: event.detail.entity } }));
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.accountHref = organizationHelper.getAccountHref(this.entity);
  }
}

window.customElements.define('parent-account', ParentAccount);
